import a from "./contact-channels78.js";
function i(r, e) {
  a(r);
  var t = /^\s+/g;
  return r.replace(t, "");
}
export {
  i as default
};
//# sourceMappingURL=contact-channels81.js.map
